export const LIST_GENERATE_DATA_ANALYSIS_REQUEST = 'LIST_GENERATE_DATA_ANALYSIS_REQUEST'
export const LIST_GENERATE_DATA_ANALYSIS_SUCCESS = 'LIST_GENERATE_DATA_ANALYSIS_SUCCESS'
export const LIST_GENERATE_DATA_ANALYSIS_FAILURE = 'LIST_GENERATE_DATA_ANALYSIS_FAILURE'

export const GENERATE_DATA_ANALYSIS_REQUEST = 'GENERATE_DATA_ANALYSIS_REQUEST'
export const GENERATE_DATA_ANALYSIS_SUCCESS = 'GENERATE_DATA_ANALYSIS_SUCCESS'
export const GENERATE_DATA_ANALYSIS_FAILURE = 'GENERATE_DATA_ANALYSIS_FAILURE'

export const LIST_PROCESS_ANALYSIS_REQUEST = 'LIST_PROCESS_ANALYSIS_REQUEST'
export const LIST_PROCESS_ANALYSIS_SUCCESS = 'LIST_PROCESS_ANALYSIS_SUCCESS'
export const LIST_PROCESS_ANALYSIS_FAILURE = 'LIST_PROCESS_ANALYSIS_FAILURE'

export const DETAIL_PROCESS_ANALYSIS_REQUEST = 'DETAIL_PROCESS_ANALYSIS_REQUEST'
export const DETAIL_PROCESS_ANALYSIS_SUCCESS = 'DETAIL_PROCESS_ANALYSIS_SUCCESS'
export const DETAIL_PROCESS_ANALYSIS_FAILURE = 'DETAIL_PROCESS_ANALYSIS_FAILURE'

export const DETAIL_LIST_PROCESS_ANALYSIS_REQUEST = 'DETAIL_LIST_PROCESS_ANALYSIS_REQUEST'
export const DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS = 'DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS'
export const DETAIL_LIST_PROCESS_ANALYSIS_FAILURE = 'DETAIL_LIST_PROCESS_ANALYSIS_FAILURE'

export const EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_REQUEST = 'EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_REQUEST'
export const EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS = 'EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_SUCCESS'
export const EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_FAILURE = 'EXPORT_DETAIL_LIST_PROCESS_ANALYSIS_FAILURE'

export const LIST_MANAGE_DATA_ANALYSIS_REQUEST = 'LIST_MANAGE_DATA_ANALYSIS_REQUEST'
export const LIST_MANAGE_DATA_ANALYSIS_SUCCESS = 'LIST_MANAGE_DATA_ANALYSIS_SUCCESS'
export const LIST_MANAGE_DATA_ANALYSIS_FAILURE = 'LIST_MANAGE_DATA_ANALYSIS_FAILURE'

export const GENERATE_MANAGE_DATA_ANALYSIS_REQUEST = 'GENERATE_MANAGE_DATA_ANALYSIS_REQUEST'
export const GENERATE_MANAGE_DATA_ANALYSIS_SUCCESS = 'GENERATE_MANAGE_DATA_ANALYSIS_SUCCESS'
export const GENERATE_MANAGE_DATA_ANALYSIS_FAILURE = 'GENERATE_MANAGE_DATA_ANALYSIS_FAILURE'

export const DELETE_MANAGE_DATA_ANALYSIS_REQUEST = 'DELETE_MANAGE_DATA_ANALYSIS_REQUEST'
export const DELETE_MANAGE_DATA_ANALYSIS_SUCCESS = 'DELETE_MANAGE_DATA_ANALYSIS_SUCCESS'
export const DELETE_MANAGE_DATA_ANALYSIS_FAILURE = 'DELETE_MANAGE_DATA_ANALYSIS_FAILURE'